<template>
    <tr class="tracker-list-item">
      <td>
        <i v-if="item.isDefault" class="mdi mdi-star-circle"></i>
      </td>

      <td>
        {{ item.name }}
      </td>

      <td class="item-type">
        <img :src="imgSrc"
              alt="logo"
              class="tracker-img">
        {{ type }}
      </td>

      <td>
        <tracker-listItem-actions :item="item"
                                  @deleted="emitReload" />
      </td>
    </tr>
  </template>

  <script>
  import TrackerListItemActions from "./actions/TrackerListItemActions.vue";

  export default {
    components: {
      TrackerListItemActions
    },

    data() {
      return {};
    },

    props: {
      item: {
        type: Object,
        required: true,
      },
    },

    computed: {
      type() {
        return {
          ["FACEBOOK_PIXEL"]: "Pixel Meta",
          ["GOOGLE_ANALYTICS"]: "Google Analytics"
        }[this.item.type];
      },
      imgSrc() {
        return {
          ["FACEBOOK_PIXEL"]: "/images/facebook-logo-blue.png",
          ["GOOGLE_ANALYTICS"]: "/images/google-analytics.svg"
        }[this.item.type];
      }
    },

    methods: {
      emitReload() {
        this.$emit("reload");
      },
    },
  };
  </script>

  <style lang="scss" scoped>

    .item-type {
      display: flex;
      align-items: center;

      .tracker-img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        margin-bottom: 4px;
      }
    }

  </style>
